import type { FeatureTypes, Toggle } from '../../legacy/api/feature-flags';

class FeatureFlagsManager {
  private static instance: FeatureFlagsManager;
  private toggles: Toggle[] = [];

  constructor() {
    if (FeatureFlagsManager.instance) {
      return FeatureFlagsManager.instance;
    }
    FeatureFlagsManager.instance = this;
  }

  expose() {
    window.FeatureFlagsManager = this;
  }

  isEnabled(name: FeatureTypes): boolean {
    return this.toggles.find((toggle) => toggle.name === name)?.enabled ?? false;
  }

  public setToggles(toggles: Toggle[]) {
    this.toggles = toggles;
  }
}

export const featureFlags = new FeatureFlagsManager();
featureFlags.expose();
